
import { apiEndpoint } from './config';
import { ACCESS_TOKEN_KEY } from './constants';

export function getAuthHeader() {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  return `Bearer ${token}`;
}

export async function api(path, data, auth=true) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (auth) {
    headers['Authorization'] = getAuthHeader();
  }

  const resp = await fetch(
    `${apiEndpoint}${path}`,
    {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    }
  );

  if (resp.status < 200 || resp.status >= 400) {
    let error;
    try {
      const json = await resp.json();
      error = json.error;
    } catch (err) {
      error = resp.statusText;
    }
    const exc = Error(error);
    exc.status = resp.status;
    throw exc;
  }

  const json = await resp.json();
  const { error } = json;
  if (error) {
    const exc = Error(error);
    exc.status = resp.status;
    throw exc;
  }
  return json;
}

export function attachmentUrl(id) {
  return `${apiEndpoint}/attachment/${id}`;
}
